import "core-js/modules/es.string.starts-with.js";
import { request } from "@/js/http/http_request";
import menuComponent from "@/components/menu/Menu.vue";
import * as orderHandler from "@/js/order/order.js";
import footerComponent from "@/components/footer/Footer.vue";
export default {
  name: "defaultProfile",
  data: function data() {
    return {
      loaded: false,
      lockerTimelapseIntervale: null
    };
  },
  computed: {
    isPublicDashbord: function isPublicDashbord() {
      return this.$route.path.startsWith("/my-dashboard/");
    }
  },
  mounted: function mounted() {
    this.loaded = true;
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.lockerTimelapseIntervale);
  },
  created: function created() {
    var _this2 = this;
    var order = orderHandler.getCurrentOrder();
    var interval = setInterval(function () {
      if (order && order.items.length > 0) {
        _this2.launchLockCancelationTimer(order);
      }
      clearInterval(interval);
    }, 1000);
  },
  methods: {
    launchLockCancelationTimer: function launchLockCancelationTimer(order) {
      this.lockCancellationTimer(order);
      var _this = this;
      this.lockerTimelapseIntervale = setInterval(function () {
        _this.lockCancellationTimer(order);
      }, 60 * 1000);
    },
    lockCancellationTimer: function lockCancellationTimer(order) {
      return request("/v1/orders/".concat(order.id_order, "/cancellation_timer/lock"), "put", null, true, "api");
    }
  },
  components: {
    "menu-component": menuComponent,
    "footer-component": footerComponent
  }
};